import { createWebHistory, createRouter } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { storeToRefs } from "pinia";
const routes = [
    {
      path: "/",
      name: "index",
      component: () => import('@/pages/home/home.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/sobre-nosotros",
      name: "aboutUs",
      component: () => import('@/pages/about-us/index.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/tienda",
      name: "shop",
      component: () => import('@/pages/shop/shop.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/carrito",
      name: "shopCart",
      component: () => import('@/pages/shop-cart/index.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/checkout",
      name: "checkout",
      component: () => import('@/pages/checkout/index.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/productos/:id",
      name: "products-details",
      component: () => import('@/pages/products/productDetail.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/contacto",
      name: "contacto",
      component: () => import('@/pages/contact-us/index.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import('@/pages/profile/index.vue'),
      meta: { layout: 'default'}
    },
    {
      path: "/login",
      name: "login",
      component: () => import('@/pages/auth/login/index.vue'),
      meta: { layout: 'blank'}
    },
    {
      path: "/registro",
      name: "register",
      component: () => import('@/pages/auth/register/index.vue'),
      meta: { layout: 'blank'}
    },
    {
      path: "/:catchAll(.*)",
      name: "Error",
      component: () => import('@/pages/specialpages/error.vue'),
      meta: { layout: 'default'}
    },
   
   
  ];
  
  let alreadyRedirected = false

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach(async to => {
    console.log('To route:', to.name)
    const authStore = useAuthStore()
    const { isLoggedIn } = storeToRefs(authStore)

    if (to.name === 'profile') {
      try {
        // Verifica la autenticación
        await authStore.checkAuth()
      } catch (error) {
        console.log('Error fetching user:', error)
  
        return { name: 'index' }
      }
    }

    // Si ya se redirigió, permite la navegación
    if (alreadyRedirected) {
      return true
    }

    // Si no está autenticado, intenta cargar el token desde el localStorage
    // if (!isLoggedIn.value) {
    //   // Si hay un token en localStorage, llama a la API para obtener el usuario (y datos del carrito)
    //   try {
    //     await authStore.checkAuth() // Este método debe hacer la llamada a la API para verificar el token y obtener el usuario
    //   } catch (error) {
    //     console.log('Error fetching user:', error)
    //     alreadyRedirected = true
        
    //     return { name: 'index', query: to.query }
    //   }
    // }
    // Si está autenticado
    if (isLoggedIn.value) {
      if (to.name === 'auth-login') {// Si está autenticado y trata de acceder a la página de login, redirige a la página de inicio
        alreadyRedirected = true
        
        return { name: 'index' }
      }
    } else {
      alreadyRedirected = true
    }
  })

  export default router;